<script setup lang="ts"></script>

<template>
  <div class="w-full min-h-px max-h-px bg-2 opacity-[0.08]" />
</template>
